import { buildQuery, requestJson } from "./apiClient";

export async function listAuditLog(params = {}) {
  return requestJson(`/api/admin/audit-log${buildQuery(params)}`);
}
